import styled, { css, keyframes } from 'styled-components'
import { TOutline } from '.'
import { colors } from '../Colors'
import { hexToRgb } from '../Utils/helpers'
// import { colors } from '../Utils/constants'

const rippleAnimation = keyframes`
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(10);
        opacity: 0.375;
    }
    100% {
        transform: scale(35);
        opacity: 0;
    }
`

export const ButtonWrapper = styled.button<{
    buttonClass?: string
    buttonSize?: string
    outline?: TOutline
    isRounded?: boolean
    isIcon?: boolean
    isLightMode?: boolean
    hasValueFilter?: boolean
    forResponsive?: boolean
}>`
    &.clickable {
        cursor: pointer;
    }

    // Disabled button
    &.btn-disabled,
    &[disabled] {
        cursor: not-allowed;
        pointer-events: none;
    }

    &.pointer-disabled {
        pointer-events: none;
    }

    &.btn-white {
        color: #333;
        background-color: #ffffff;
        border: 1px solid #d6d6d6;
        &:hover,
        &:focus {
            background-color: #ffffff;
            box-shadow: none;
        }
    }
    /** NEW **/
    border-radius: 8px;
    border: none;
    font-weight: 500;
    padding: 0 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    outline: none !important;
    ${({ buttonClass, isLightMode, hasValueFilter }) => {
        switch (buttonClass) {
            case 'primary':
                return css<{ outline?: TOutline }>`
                    color: #fff !important;
                    background-color: ${colors.secondary[40]} !important;
                    border: 2px solid ${colors.secondary[40]} !important;
                    &:hover {
                        background-color: ${colors.secondary[50]} !important;
                        border: 2px solid ${colors.secondary[50]} !important;
                    }
                    &:focus,
                    &:active {
                        background-color: ${colors.secondary[50]} !important;
                        border: 2px solid ${colors.secondary[50]} !important;
                        box-shadow: inset 0 0 0 1px ${colors.secondary[100]} !important;
                    }
                    &.btn-disabled,
                    &[disabled] {
                        color: ${colors.grey[80]} !important;
                        background-color: ${colors.grey[95]} !important;
                        border: 2px solid ${colors.grey[95]} !important;
                    }
                    ${({ outline }) => {
                        switch (outline) {
                            default:
                            case 'solid':
                                return css``
                            case 'none':
                                return css`
                                    background-color: ${colors.secondary[100]} !important;
                                    color: ${colors.secondary[40]} !important;
                                    border: 2px solid transparent !important;
                                    &:hover {
                                        color: ${colors.secondary[40]} !important;
                                        border: 2px solid transparent !important;
                                        background-color: ${colors.secondary[95]} !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.secondary[95]} !important;
                                        box-shadow: inset 0 0 0 1px ${colors.secondary[100]} !important;
                                        border: 2px solid ${colors.secondary[50]} !important;
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid transparent !important;
                                    }
                                `
                            case 'outline':
                                return css`
                                    background-color: transparent !important;
                                    color: ${colors.secondary[40]} !important;
                                    border: none !important;
                                    box-shadow: inset 0 0 0 1px ${colors.secondary[50]} !important;
                                    &:hover {
                                        color: ${colors.secondary[40]} !important;
                                        background-color: rgba(
                                            ${hexToRgb(colors.secondary[50])!.toString()},
                                            0.15
                                        ) !important;
                                        border: none !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: rgba(
                                            ${hexToRgb(colors.secondary[50])!.toString()},
                                            0.15
                                        ) !important;
                                        box-shadow: inset 0 0 0 2px ${colors.secondary[50]} !important;
                                        border: none !important;
                                        &::before {
                                            content: ' ';
                                            position: absolute;
                                            left: 2px;
                                            top: 2px;
                                            width: calc(100% - 4px);
                                            height: calc(100% - 4px);
                                            pointer-events: none;
                                            user-select: none;
                                            border: 1px solid ${colors.secondary[100]};
                                            border-radius: 6px;
                                        }
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid ${colors.grey[95]} !important;
                                        box-shadow: none !important;
                                    }
                                `
                        }
                    }}
                `
            case 'default':
                if (hasValueFilter) {
                    return css`
                        border: 1px solid #a0c1ff;
                        display: inline-block;
                        overflow: hidden;
                        background: #eff5ff;
                        color: #003699;
                        &:before {
                            content: '';
                            top: 0px;
                            left: 0px;
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            border-radius: 6px;
                            border: 4px solid #fff !important;
                        }
                    `
                }
                return css<{ outline?: TOutline }>`
                    color: ${colors.grey[20]} !important;
                    background-color: ${colors.neutral[95]} !important;
                    border: 2px solid ${colors.neutral[95]} !important;
                    &:hover {
                        background-color: ${colors.neutral[90]} !important;
                        border: 2px solid ${colors.neutral[90]} !important;
                    }
                    &:focus,
                    &:active {
                        background-color: ${colors.neutral[90]} !important;
                        border: 2px solid ${colors.neutral[80]} !important;
                        box-shadow: inset 0 0 0 1px ${colors.neutral[100]} !important;
                    }
                    &.btn-disabled,
                    &[disabled] {
                        color: ${colors.grey[80]} !important;
                        background-color: ${colors.grey[95]} !important;
                        border: 2px solid ${colors.grey[95]} !important;
                    }

                    ${({ outline }) => {
                        switch (outline) {
                            default:
                            case 'solid':
                                return css``
                            case 'none':
                                return css`
                                    background-color: ${colors.neutral[100]} !important;
                                    color: ${colors.grey[20]} !important;
                                    border: 2px solid transparent !important;
                                    &:hover {
                                        color: ${colors.grey[20]} !important;
                                        border: 2px solid transparent !important;
                                        background-color: ${colors.neutral[95]} !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.neutral[95]} !important;
                                        box-shadow: inset 0 0 0 1px ${colors.neutral[100]} !important;
                                        border: 2px solid ${colors.neutral[80]} !important;
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid transparent !important;
                                    }
                                `
                            case 'outline':
                                return css`
                                    background-color: transparent !important;
                                    color: ${colors.grey[20]} !important;
                                    border: none !important;
                                    box-shadow: inset 0 0 0 1px ${colors.neutral[80]} !important;
                                    &:hover {
                                        color: ${colors.grey[20]} !important;
                                        background-color: rgba(
                                            ${hexToRgb(colors.neutral[50])!.toString()},
                                            0.15
                                        ) !important;
                                        border: none !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: rgba(
                                            ${hexToRgb(colors.neutral[50])!.toString()},
                                            0.15
                                        ) !important;
                                        box-shadow: inset 0 0 0 2px ${colors.neutral[80]} !important;
                                        border: none !important;
                                        &::before {
                                            content: ' ';
                                            position: absolute;
                                            left: 2px;
                                            top: 2px;
                                            width: calc(100% - 4px);
                                            height: calc(100% - 4px);
                                            pointer-events: none;
                                            user-select: none;
                                            border: 1px solid ${colors.neutral[100]};
                                            border-radius: 6px;
                                        }
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid ${colors.grey[95]} !important;
                                        box-shadow: none !important;
                                    }
                                `
                        }
                    }}
                `
            case 'danger':
                return css<{ outline?: TOutline }>`
                    color: ${colors.error[100]} !important;
                    background-color: ${colors.error[40]} !important;
                    border: 2px solid ${colors.error[40]} !important;
                    &:hover {
                        background-color: ${colors.error[50]} !important;
                        border: 2px solid ${colors.error[50]} !important;
                    }
                    &:focus,
                    &:active {
                        background-color: ${colors.error[50]} !important;
                        border: 2px solid ${colors.error[50]} !important;
                        box-shadow: inset 0 0 0 1px ${colors.error[100]} !important;
                    }
                    &.btn-disabled,
                    &[disabled] {
                        color: ${colors.grey[80]} !important;
                        background-color: ${colors.grey[95]} !important;
                        border: 2px solid ${colors.grey[95]} !important;
                    }
                    ${({ outline }) => {
                        switch (outline) {
                            default:
                            case 'solid':
                                return css``
                            case 'none':
                                return css`
                                    background-color: ${colors.error[100]} !important;
                                    color: ${colors.error[40]} !important;
                                    border: 2px solid transparent !important;
                                    &:hover {
                                        color: ${colors.error[40]} !important;
                                        border: 2px solid transparent !important;
                                        background-color: ${colors.error[95]} !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.error[95]} !important;
                                        box-shadow: inset 0 0 0 1px ${colors.error[100]} !important;
                                        color: ${colors.error[40]} !important;
                                        border: 2px solid ${colors.error[50]} !important;
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid transparent !important;
                                    }
                                `
                            case 'outline':
                                return css`
                                    background-color: transparent !important;
                                    color: ${colors.error[40]} !important;
                                    border: none !important;
                                    box-shadow: inset 0 0 0 1px ${colors.error[50]} !important;
                                    &:hover {
                                        color: ${colors.error[40]} !important;
                                        background-color: rgba(
                                            ${hexToRgb(colors.error[50])!.toString()},
                                            0.15
                                        ) !important;
                                        border: none !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.error[95]} !important;
                                        box-shadow: inset 0 0 0 2px ${colors.error[50]} !important;
                                        border: none !important;
                                        &::before {
                                            content: ' ';
                                            position: absolute;
                                            left: 2px;
                                            top: 2px;
                                            width: calc(100% - 4px);
                                            height: calc(100% - 4px);
                                            pointer-events: none;
                                            user-select: none;
                                            border: 1px solid ${colors.error[100]};
                                            border-radius: 6px;
                                        }
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid ${colors.grey[95]} !important;
                                        box-shadow: none !important;
                                    }
                                `
                        }
                    }}
                `
            case 'info':
                if (!isLightMode) {
                    return css<{ outline?: TOutline }>`
                        color: ${colors.primary[100]} !important;
                        background-color: ${colors.primary[40]} !important;
                        border: 2px solid ${colors.primary[40]} !important;
                        &:hover {
                            background-color: ${colors.primary[50]} !important;
                            border: 2px solid ${colors.primary[50]} !important;
                        }
                        &:focus,
                        &:active {
                            background-color: ${colors.primary[40]} !important;
                            border: 2px solid ${colors.primary[40]} !important;
                            box-shadow: inset 0 0 0 1px ${colors.primary[100]} !important;
                        }
                        &.btn-disabled,
                        &[disabled] {
                            color: ${colors.grey[80]} !important;
                            background-color: ${colors.grey[95]} !important;
                            border: 2px solid ${colors.grey[95]} !important;
                        }
                        ${({ outline }) => {
                            switch (outline) {
                                default:
                                case 'solid':
                                    return css``
                                case 'none':
                                    return css`
                                        background-color: ${colors.primary[100]} !important;
                                        color: ${colors.primary[40]} !important;
                                        border: 2px solid transparent !important;
                                        &:hover {
                                            color: ${colors.primary[40]} !important;
                                            border: 2px solid transparent !important;
                                            background-color: ${colors.primary[95]} !important;
                                        }
                                        &:focus,
                                        &:active {
                                            background-color: ${colors.primary[95]} !important;
                                            box-shadow: inset 0 0 0 1px ${colors.primary[100]} !important;
                                            color: ${colors.primary[40]} !important;
                                            border: 2px solid ${colors.primary[70]} !important;
                                        }
                                        &[disabled] {
                                            color: ${colors.grey[80]} !important;
                                            background-color: ${colors.grey[100]} !important;
                                            border: 1px solid transparent !important;
                                        }
                                    `
                                case 'outline':
                                    return css`
                                        background-color: transparent !important;
                                        color: ${colors.primary[40]} !important;
                                        border: none !important;
                                        box-shadow: inset 0 0 0 1px ${colors.primary[70]} !important;
                                        &:hover {
                                            color: ${colors.primary[40]} !important;
                                            background-color: rgba(
                                                ${hexToRgb(colors.primary[50])!.toString()},
                                                0.15
                                            ) !important;
                                            border: none !important;
                                        }
                                        &:focus,
                                        &:active {
                                            background-color: ${colors.primary[95]} !important;
                                            box-shadow: inset 0 0 0 2px ${colors.primary[70]} !important;
                                            border: none !important;
                                            &::before {
                                                content: ' ';
                                                position: absolute;
                                                left: 2px;
                                                top: 2px;
                                                width: calc(100% - 4px);
                                                height: calc(100% - 4px);
                                                pointer-events: none;
                                                user-select: none;
                                                border: 1px solid ${colors.primary[100]};
                                                border-radius: 6px;
                                            }
                                        }
                                        &[disabled] {
                                            color: ${colors.grey[80]} !important;
                                            background-color: ${colors.grey[100]} !important;
                                            border: 1px solid ${colors.grey[95]} !important;
                                            box-shadow: none !important;
                                        }
                                    `
                            }
                        }}
                    `
                }
                // info already have light mode
                return css<{ outline?: TOutline }>`
                    color: ${colors.primary[40]} !important;
                    background-color: ${colors.primary[95]} !important;
                    border: 2px solid ${colors.primary[95]} !important;
                    &:hover {
                        background-color: ${colors.primary[90]} !important;
                        border: 2px solid ${colors.primary[90]} !important;
                    }
                    &:focus,
                    &:active {
                        background-color: ${colors.primary[90]} !important;
                        border: 2px solid ${colors.primary[70]} !important;
                        box-shadow: inset 0 0 0 1px ${colors.primary[100]} !important;
                    }
                    &.btn-disabled,
                    &[disabled] {
                        color: ${colors.grey[80]} !important;
                        background-color: ${colors.grey[95]} !important;
                        border: 2px solid ${colors.grey[95]} !important;
                    }
                    ${({ outline }) => {
                        switch (outline) {
                            default:
                            case 'solid':
                                return css``
                            case 'none':
                                return css`
                                    background-color: ${colors.primary[100]} !important;
                                    color: ${colors.primary[40]} !important;
                                    border: 2px solid transparent !important;
                                    &:hover {
                                        color: ${colors.primary[40]} !important;
                                        border: 2px solid transparent !important;
                                        background-color: ${colors.primary[95]} !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.primary[95]} !important;
                                        box-shadow: inset 0 0 0 1px ${colors.primary[100]} !important;
                                        color: ${colors.primary[40]} !important;
                                        border: 2px solid ${colors.primary[70]} !important;
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid transparent !important;
                                    }
                                `
                            case 'outline':
                                return css`
                                    background-color: transparent !important;
                                    color: ${colors.primary[40]} !important;
                                    border: none !important;
                                    box-shadow: inset 0 0 0 1px ${colors.primary[70]} !important;
                                    &:hover {
                                        color: ${colors.primary[40]} !important;
                                        background-color: rgba(
                                            ${hexToRgb(colors.primary[50])!.toString()},
                                            0.15
                                        ) !important;
                                        border: none !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.primary[95]} !important;
                                        box-shadow: inset 0 0 0 2px ${colors.primary[70]} !important;
                                        border: none !important;
                                        &::before {
                                            content: ' ';
                                            position: absolute;
                                            left: 2px;
                                            top: 2px;
                                            width: calc(100% - 4px);
                                            height: calc(100% - 4px);
                                            pointer-events: none;
                                            user-select: none;
                                            border: 1px solid ${colors.primary[100]};
                                            border-radius: 6px;
                                        }
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid ${colors.grey[95]} !important;
                                        box-shadow: none !important;
                                    }
                                `
                        }
                    }}
                `
            case 'outline':
                // OLD style outline (Used for keep consistent of old component)
                return css`
                    background-color: transparent;
                    border: 1px solid ${colors.secondary[40]};
                    color: ${colors.secondary[40]};
                    &:hover,
                    &:focus {
                        background-color: #fff;
                    }
                `
            case 'transparent':
                return css<{ outline: TOutline }>`
                    color: #666;
                    background-color: transparent;
                    border: unset;
                    &:hover {
                        background-color: #e9e9f2;
                        border: 1px solid #e9e9f2;
                    }
                    &:focus,
                    &:active {
                        background-color: #d6d6e0 !important;
                        border: 1px solid #fff !important;
                        box-shadow: 0 0 0 1px #d6d6e0 !important;
                    }
                    ${({ outline }) => {
                        switch (outline) {
                            case 'outline':
                                return css``
                            case 'solid':
                                return css``
                            case 'none':
                            default:
                                return ''
                        }
                    }}
                `
            case 'opacity':
                return css<{ outline: TOutline }>`
                    color: #666;
                    background-color: transparent;
                    border: unset;
                    &:hover {
                        background-color: rgba(174, 174, 174, 0.5);
                        border: 1px solid #e9e9f2;
                    }
                    &:focus,
                    &:active {
                        background-color: rgba(174, 174, 174, 0.5) !important;
                        border: 1px solid #fff !important;
                        box-shadow: 0 0 0 1px #d6d6e0 !important;
                    }
                `
            case 'highlight':
                return css<{ outline?: TOutline }>`
                    color: ${colors.primary[40]} !important;
                    background-color: ${colors.primary[95]} !important;
                    border: 2px solid ${colors.primary[95]} !important;
                    &:hover {
                        background-color: ${colors.primary[90]} !important;
                        border: 2px solid ${colors.primary[90]} !important;
                    }
                    &:focus,
                    &:active {
                        background-color: ${colors.primary[90]} !important;
                        border: 2px solid ${colors.primary[70]} !important;
                        box-shadow: inset 0 0 0 1px ${colors.primary[100]} !important;
                    }
                    &.btn-disabled,
                    &[disabled] {
                        color: ${colors.grey[80]} !important;
                        background-color: ${colors.grey[95]} !important;
                        border: 2px solid ${colors.grey[95]} !important;
                    }
                    ${({ outline }) => {
                        switch (outline) {
                            default:
                            case 'solid':
                                return css``
                            case 'none':
                                return css`
                                    background-color: ${colors.primary[100]} !important;
                                    color: ${colors.primary[40]} !important;
                                    border: 2px solid transparent !important;
                                    &:hover {
                                        color: ${colors.primary[40]} !important;
                                        border: 2px solid transparent !important;
                                        background-color: ${colors.primary[95]} !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.primary[95]} !important;
                                        box-shadow: inset 0 0 0 1px ${colors.primary[100]} !important;
                                        color: ${colors.primary[40]} !important;
                                        border: 2px solid ${colors.primary[70]} !important;
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid transparent !important;
                                    }
                                `
                            case 'outline':
                                return css`
                                    background-color: ${colors.primary[100]} !important;
                                    color: ${colors.primary[40]} !important;
                                    border: none !important;
                                    box-shadow: inset 0 0 0 1px ${colors.primary[70]} !important;
                                    &:hover {
                                        color: ${colors.primary[40]} !important;
                                        background-color: rgba(
                                            ${hexToRgb(colors.primary[50])!.toString()},
                                            0.15
                                        ) !important;
                                        border: none !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.primary[95]} !important;
                                        box-shadow: inset 0 0 0 2px ${colors.primary[70]} !important;
                                        border: none !important;
                                        &::before {
                                            content: ' ';
                                            position: absolute;
                                            left: 2px;
                                            top: 2px;
                                            width: calc(100% - 4px);
                                            height: calc(100% - 4px);
                                            pointer-events: none;
                                            user-select: none;
                                            border: 1px solid ${colors.primary[100]};
                                            border-radius: 6px;
                                        }
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid ${colors.grey[95]} !important;
                                        box-shadow: none !important;
                                    }
                                `
                        }
                    }}
                `
            case 'ai':
                return css<{ outline?: TOutline }>`
                    color: #c006e9 !important;
                    background-color: ${colors.primary[95]} !important;
                    border: 2px solid ${colors.primary[95]} !important;
                    &:hover {
                        background-color: ${colors.primary[90]} !important;
                        border: 2px solid ${colors.primary[90]} !important;
                    }
                    &:focus,
                    &:active {
                        background-color: ${colors.primary[90]} !important;
                        border: 2px solid ${colors.primary[70]} !important;
                        box-shadow: inset 0 0 0 1px ${colors.primary[100]} !important;
                    }
                    &.btn-disabled,
                    &[disabled] {
                        color: ${colors.grey[80]} !important;
                        background-color: ${colors.grey[95]} !important;
                        border: 2px solid transparent !important;
                    }
                    ${({ outline }) => {
                        switch (outline) {
                            default:
                            case 'solid':
                                return css`
                                    background: linear-gradient(90deg, #e0369b 0%, #c006e9 100%) !important;
                                    color: #fff !important;
                                    border: 2px solid transparent !important;
                                    &:hover {
                                        border: 2px solid #c006e9 !important;
                                        background: linear-gradient(
                                            90deg,
                                            rgba(224, 54, 155, 0.8) 0%,
                                            rgba(192, 6, 233, 0.8) 100%
                                        );
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.primary[90]} !important;
                                        border: 2px solid #c006e9 !important;
                                        box-shadow: inset 0 0 0 1px ${colors.primary[100]} !important;
                                    }
                                `
                            case 'none':
                                return css`
                                    background-color: ${colors.primary[100]} !important;
                                    color: ${colors.primary[40]} !important;
                                    border: 2px solid transparent !important;
                                    &:hover {
                                        color: ${colors.primary[40]} !important;
                                        border: 2px solid transparent !important;
                                        background-color: ${colors.primary[95]} !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: ${colors.primary[95]} !important;
                                        box-shadow: inset 0 0 0 1px ${colors.primary[100]} !important;
                                        color: ${colors.primary[40]} !important;
                                        border: 2px solid ${colors.primary[70]} !important;
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid transparent !important;
                                    }
                                `
                            case 'outline':
                                return css`
                                    background-color: ${colors.primary[100]} !important;
                                    color: #c006e9 !important;
                                    border: none !important;
                                    box-shadow: inset 0 0 0 1px #c006e9 !important;
                                    &:hover {
                                        color: #c006e9 !important;
                                        background-color: #f0dcf5 !important;
                                        border: none !important;
                                    }
                                    &:focus,
                                    &:active {
                                        background-color: #f0dcf5 !important;
                                        box-shadow: inset 0 0 0 2px #c006e9 !important;
                                        border: none !important;
                                        &::before {
                                            content: ' ';
                                            position: absolute;
                                            left: 2px;
                                            top: 2px;
                                            width: calc(100% - 4px);
                                            height: calc(100% - 4px);
                                            pointer-events: none;
                                            user-select: none;
                                            border: 1px solid ${colors.primary[100]};
                                            border-radius: 6px;
                                        }
                                    }
                                    &[disabled] {
                                        color: ${colors.grey[80]} !important;
                                        background-color: ${colors.grey[100]} !important;
                                        border: 1px solid ${colors.grey[95]} !important;
                                        box-shadow: none !important;
                                    }
                                `
                        }
                    }}
                `
            default:
                return ''
        }
    }}
    ${({ buttonSize }) => {
        switch (buttonSize) {
            case 'xs':
                return css`
                    font-size: 12px;
                    height: 28px;
                    line-height: 20px;
                `
            case 'sm':
                return css`
                    font-size: 12px;
                    height: 32px;
                    line-height: 20px;
                `
            case 'md-h':
                return css`
                    font-size: 14px;
                    height: 40px;
                    line-height: 20px;
                `
            case 'md-up':
                return css`
                    font-size: 14px;
                    height: 44px;
                    line-height: 20px;
                `
            case 'lg':
                return css`
                    font-size: 15px;
                    height: 48px;
                    line-height: 20px;
                `
            case 'md':
            default:
                return css`
                    font-size: 14px;
                    height: 40px;
                    line-height: 20px;
                `
        }
    }}

    ${({ isIcon }) => {
        if (!isIcon) {
            return ''
        }
        return css<{ buttonSize: string }>`
            padding: 0;
            svg {
                pointer-events: none;
                width: 16px;
                height: 16px;
            }
            ${({ buttonSize }) => {
                switch (buttonSize) {
                    case 'xs':
                    case 'sm':
                        return css`
                            width: 32px;
                            height: 32px;
                            min-width: 32px;
                            min-height: 32px;
                            font-size: 12px;
                            height: 32px;
                            line-height: 20px;
                        `
                    case 'lg':
                    case 'md':
                    default:
                        return css`
                            font-size: 14px;
                            height: 40px;
                            line-height: 20px;
                            width: 40px;
                            height: 40px;
                            min-width: 40px;
                            min-height: 40px;
                            svg {
                                width: 20px;
                                height: 20px;
                            }
                        `
                }
            }}
        `
    }}
    ${({ isRounded }) => {
        if (!isRounded) {
            return ''
        }
        return css`
            border-radius: 48px;
            &::before {
                border-radius: 48px !important;
            }
        `
    }}

    ${({ forResponsive, hasValueFilter }) => {
        if (forResponsive && !hasValueFilter) {
            return css`
                border: none !important;
                height: 32px;
                box-shadow: none !important;
                background: #f1f2f4 !important;
                padding: 0 8px;
                &::before {
                    border: none !important;
                }
            `
        }
        if (hasValueFilter && forResponsive) {
            return css`
                background: #eff5ff !important;
                border: none !important;
                height: 32px;
                box-shadow: none !important;
                padding: 0 8px;
                &::before {
                    border: none !important;
                }
            `
        }

        return ''
    }}
`

export const Ripple = styled.span<{ buttonClass?: string }>`
    width: 20px;
    height: 20px;
    position: absolute;
    display: block;
    content: '';
    border-radius: 100%;
    opacity: 1;
    animation: 1s ease 1 forwards ${rippleAnimation};
    ${({ buttonClass }) => {
        switch (buttonClass) {
            case 'primary':
                return css<{ isOutline: boolean }>`
                    background-color: ${colors.secondary[40]}80;
                    ${({ isOutline }) => {
                        if (!isOutline) {
                            return ''
                        }
                        return css`
                            background-color: #fff;
                        `
                    }}
                `
            case 'default':
                return css<{ isOutline: boolean }>`
                    background-color: #f4f4f7;
                    ${({ isOutline }) => {
                        if (!isOutline) {
                            return ''
                        }
                        return css`
                            background-color: #fff;
                        `
                    }}
                `
            case 'danger':
                return css<{ isOutline: boolean }>`
                    background-color: #f85a5a;
                    ${({ isOutline }) => {
                        if (!isOutline) {
                            return ''
                        }
                        return css`
                            background-color: rgba(255, 255, 255, 0.9);
                        `
                    }}
                `
            case 'outline':
                return css`
                    background-color: #fff;
                `
            default:
                return ''
        }
    }}
`

export const IconWrapper = styled.div<{ isLeft: boolean }>`
    display: flex;
    align-items: center;
    ${({ isLeft }) => {
        if (isLeft) {
            return css`
                margin-right: 6px;
            `
        }
        return css`
            margin-left: 6px;
        `
    }}
`
